import { BUTTON_DISABLED_OPACITY } from '../constants';
import { ButtonPropsWithTheme } from '../types';

const disabledStyle = (props: ButtonPropsWithTheme): string => {
  if (props.disabled) {
    return `
      opacity: ${BUTTON_DISABLED_OPACITY};
      cursor: not-allowed;
    `;
  }
  return '';
};

export default disabledStyle;
